import React, { useState } from "react";
import styled from "styled-components";

import LiveSoccer from "../components/live/LiveSoccer";
import LiveBaseball from "../components/live/LiveBaseball";
import LiveBasketball from "../components/live/LiveBasketball";
import LiveTennis from "../components/live/LiveTennis";
import LiveVolleyball from "../components/live/LiveVolleyball";

const LivePage = ({ pathname }) => {
  return pathname === "/live/soccer" || pathname === "/live" ? (
    <LiveSoccer></LiveSoccer>
  ) : pathname === "/live/baseball" ? (
    <LiveBaseball></LiveBaseball>
  ) : pathname === "/live/basketball" ? (
    <LiveBasketball></LiveBasketball>
  ) : pathname === "/live/tennis" ? (
    <LiveTennis></LiveTennis>
  ) : pathname === "/live/volleyball" ? (
    <LiveVolleyball></LiveVolleyball>
  ) : (
    <></>
  );
};

export default LivePage;
